import { supabase } from "@/integrations/supabase/client";
import { Tables } from "@/types/database.types";
import { FacebookTracking } from "@/utils/facebookTracking";

export async function updateOrganization(
  organizationId: string,
  data: Partial<Tables<"organizations">>
): Promise<void> {
  try {
    const { error } = await supabase
      .from("organizations")
      .update(data)
      .eq("id", organizationId);

    if (error) {
      throw error;
    }
  } catch (error) {
    console.error("Error updating organization:", error);
    throw error;
  }
}

/**
 * Updates organization with Facebook Click ID tracking data
 * This is used as a backup method if the trigger doesn't capture fbclid from user metadata
 */
export async function updateOrganizationWithFbclid(
  organizationId: string
): Promise<{ success: boolean; fbclid?: string; error?: string }> {
  try {
    // Capture current fbclid from Facebook tracking
    const fbclid = FacebookTracking.getFbclid();
    
    if (!fbclid) {
      console.log("[Organizations] No fbclid found - user likely came from organic traffic");
      return { success: true }; // Not an error, just no fbclid to capture
    }

    const fbclid_timestamp = Date.now();
    
    console.log("[Organizations] Updating organization with fbclid:", {
      organizationId,
      fbclid: fbclid.substring(0, 20) + '...',
      timestamp: fbclid_timestamp
    });

    const { error } = await supabase
      .from("organizations")
      .update({ 
        fbclid, 
        fbclid_timestamp 
      })
      .eq("id", organizationId);

    if (error) {
      console.error("[Organizations] Failed to update organization with fbclid:", error);
      return { success: false, error: error.message };
    }

    console.log("[Organizations] Successfully updated organization with fbclid");
    return { success: true, fbclid };
    
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : "Unknown error";
    console.error("[Organizations] Error updating organization with fbclid:", errorMessage);
    return { success: false, error: errorMessage };
  }
} 